// Room Door Lock (102) — "someone at the door is asking to be let in".
//
// Seen on hardware 2026-09-29 (1085864): the lock's MCU reports Tuya DP 9 as a
// VALUE counting down one second at a time —
//
//   55 AA 00 05 00 08 | 09 02 00 04 | 00 00 00 15 | cs     (DP 9 = 21 s left)
//   55 AA 00 05 00 08 | 09 02 00 04 | 00 00 00 05 | cs     (…5 s left)
//
// and the ESP says it on `<uid>/client` as `[uid]Unlock Requested#Lock` (several
// times over the window). That is a REMOTE UNLOCK REQUEST: the lock waits for the
// countdown for someone to open it from the app. The app answers the only way it
// can today — the same LOCKUNLOCK as the Open Room Door Lock button, behind the
// same fingerprint/PIN check.
//
// The plain-text message carries no countdown, so the window is timed here from
// the last request heard. The `RAW..:` lines around it are the firmware's debug
// echo of the serial frames and are ignored.

/** How long a request stays on screen after the last "Unlock Requested" heard. */
export const UNLOCK_REQUEST_WINDOW_MS = 30 * 1000;

export function isUnlockRequest(message) {
  const body = String(message ?? '').replace(/^\[[^\]]*\]/, '');
  return /^\s*Unlock Requested\b/i.test(body);
}

/**
 * The DP 9 countdown, when the firmware's RAW debug echo of a 0x05 frame is what
 * arrived — seconds left, or null. Only a hint: the debug echo may be switched
 * off in production firmware, and the screen must not depend on it.
 */
export function unlockRequestSecondsLeft(message) {
  const body = String(message ?? '').replace(/^\[[^\]]*\]/, '');
  const m = /^RAW\d+:\s*85 170 0 5 0 8 9 2 0 4 (\d+) (\d+) (\d+) (\d+) \d+\s*$/.exec(body.trim());
  if (!m) return null;
  return ((Number(m[1]) * 256 + Number(m[2])) * 256 + Number(m[3])) * 256 + Number(m[4]);
}
